import gql from 'graphql-tag';

const ANSWER_MULTIPLE = gql`
mutation answerMultiple($tester:ID!, $question:ID!, $answer:[ID!]!){
    answerMultipleQuestion(participantId: $tester, campaignQuestionId: $question, answer: $answer)
}
`;

export default ANSWER_MULTIPLE;